module.exports = __webpack_public_path__ + "static/media/parachute1.02d45ba9.png";